import {
  MessageRatingFragment,
  useGetMyMessageRatingsQuery,
} from '@shared/generated/graphql';
import { useMemo } from 'react';

export type MessageRatingsById = ReadonlyMap<string, MessageRatingFragment>;

export function useMessageRatings(messageIds: readonly string[]): {
  ratingsByMessageId: MessageRatingsById;
  hasLoaded: boolean;
} {
  const { data, previousData } = useGetMyMessageRatingsQuery({
    variables: { input: { messageIds: [...messageIds] } },
    skip: messageIds.length === 0,
  });
  // NOTE(aman): A new Vee reply changes the variables, so keep showing the last
  // result while the new one loads; only the new result enables the thumbs.
  const ratings = (data ?? previousData)?.myMessageRatings;
  const ratingsByMessageId = useMemo(
    () => new Map((ratings ?? []).map((rating) => [rating.messageId, rating])),
    [ratings]
  );
  const hasLoaded = messageIds.length === 0 || Boolean(data);
  return useMemo(
    () => ({ ratingsByMessageId, hasLoaded }),
    [ratingsByMessageId, hasLoaded]
  );
}
